import { render } from "./dezembro.vue?vue&type=template&id=c48fc546"
import script from "./dezembro.vue?vue&type=script&lang=js"
export * from "./dezembro.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__